var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('rect', {
      attrs: {
        "fill": "#D43C3F",
        "width": "20",
        "height": "20",
        "rx": "6"
      }
    }), _c('g', {
      attrs: {
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M13 5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
        "opacity": ".3"
      }
    }), _c('path', {
      attrs: {
        "d": "M14.882 7.925a2.132 2.132 0 01-2.807-2.807 3.05 3.05 0 00-.26-.013H7.08A3.088 3.088 0 004 8.185v4.736A3.088 3.088 0 007.079 16h4.737a3.088 3.088 0 003.079-3.079V8.184a3.05 3.05 0 00-.013-.259zM12.72 9.32l-1.895 2.368a.552.552 0 01-.785.08l-1.462-1.218-1.542 1.928a.551.551 0 01-.777.086.553.553 0 01-.086-.777l1.895-2.368a.553.553 0 01.785-.08l1.461 1.219 1.543-1.929a.553.553 0 01.863.69z"
      }
    })])])]));
  }
};